// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__XFcKB","checkboxCol":"Table_checkboxCol__3hj-I","emailCol":"Table_emailCol__vmUWK","actionCol":"Table_actionCol__wVqyk"};